var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-banner-box"},[_c('div',{staticClass:"img-box",class:{'bg1':_vm.num==1,'bg2':_vm.num==2,'bg3':_vm.num==3,'bg4':_vm.num==4,'bg5':_vm.num==5}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.title)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }